import gql from 'graphql-tag';

import type {
  InsertUserEmailRequest,
  InsertUserEmailResponse,
} from '@coursera/grpc-types-useremails/coursera/proto/useremails/v1beta1/user_emails_api';

export type InsertUserEmailMutationVariables = {
  input: InsertUserEmailRequest;
};

export type InsertUserEmailMutationResult = {
  InsertUserEmailResponse: InsertUserEmailResponse;
};

export const InsertUserEmailMutation = gql`
  mutation InsertUserEmail($input: InsertUserEmailRequest) {
    InsertUserEmailResponse(input: $input)
      @rest(type: "InsertUserEmail", path: "grpc/useremails/v1/UserEmailsAPI/InsertUserEmail", method: "POST") {
      userEmail
    }
  }
`;
